import { Phone, Mail, Instagram, Facebook, MapPin } from "lucide-react";
import { BRAND } from "@/data/content";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0A0A0B] text-white pt-24 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-12 md:gap-10 pb-16 border-b border-white/10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-4">
              <img
                src={BRAND.logo}
                alt="Broady Home Services"
                className="h-14 w-14 object-contain rounded-lg bg-white p-1"
              />
              <div className="font-serif-display text-4xl tracking-tight">
                Broady<span className="text-[#C8A44D]">.</span>
              </div>
            </div>
            <p className="mt-4 text-white/60 text-sm font-light max-w-sm leading-relaxed">
              {BRAND.tagline} Premium handyman services across the Las Vegas
              Valley, owned and operated by {BRAND.owner}.
            </p>
            <div className="flex items-center gap-3 mt-7">
              <a
                href="https://www.instagram.com/"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-instagram"
                aria-label="Instagram"
                className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center hover:border-[#C8A44D] hover:text-[#C8A44D] transition-colors"
              >
                <Instagram size={16} strokeWidth={1.5} />
              </a>
              <a
                href="https://www.facebook.com/"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-facebook"
                aria-label="Facebook"
                className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center hover:border-[#C8A44D] hover:text-[#C8A44D] transition-colors"
              >
                <Facebook size={16} strokeWidth={1.5} />
              </a>
              <a
                href="https://www.google.com/maps/search/Broady+Home+Services+Las+Vegas"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-google"
                aria-label="Google Business"
                className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center hover:border-[#C8A44D] hover:text-[#C8A44D] transition-colors"
              >
                <MapPin size={16} strokeWidth={1.5} />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow text-white/40">Contact</div>
            <div className="mt-5 space-y-4 text-sm">
              <a
                href={`tel:${BRAND.phoneRaw}`}
                data-testid="footer-phone"
                className="flex items-center gap-3 text-white/85 hover:text-[#C8A44D]"
              >
                <Phone size={14} strokeWidth={1.5} className="text-[#C8A44D]" />
                {BRAND.phone}
              </a>
              <a
                href={`mailto:${BRAND.email}`}
                data-testid="footer-email"
                className="flex items-center gap-3 text-white/85 hover:text-[#C8A44D] break-all"
              >
                <Mail size={14} strokeWidth={1.5} className="text-[#C8A44D]" />
                {BRAND.email}
              </a>
            </div>
          </div>

          <div className="md:col-span-4">
            <div className="eyebrow text-white/40">Service Area</div>
            <div className="mt-5 grid grid-cols-2 gap-y-2 gap-x-4 text-sm text-white/70">
              {BRAND.areas.map((a) => (
                <span key={a}>{a}</span>
              ))}
            </div>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-white/45">
          <div data-testid="footer-copyright">
            © {new Date().getFullYear()} Broady Home Services. All rights reserved.
          </div>
          <div className="flex items-center gap-8">
            <a href="#" data-testid="footer-privacy" className="hover:text-white">
              Privacy Policy
            </a>
            <a href="#" data-testid="footer-terms" className="hover:text-white">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
